
import { Base } from '../base-component';
import './get-the-app-banner.component.scss';

export class GetTheAppBanner extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){

	}

	bindEvents() {

	}
}


// WEBPACK FOOTER //
// ./components/get-the-app-banner/get-the-app-banner.component.ts